export const remToPixel = (rem) => {
  const rootFontSize = parseFloat(
    window.getComputedStyle(document.documentElement).fontSize
  );
  const pixels = rem * rootFontSize;
  return pixels;
};

export const createDebouncer = (wait) => (fn) => {
  let i = 0;
  return (...args) => {
    const currentI = ++i;
    wait(() => {
      if (currentI === i) {
        fn(...args);
      }
    });
  };
};

// https://stackoverflow.com/questions/8495687/split-array-into-chunks#comment84212474_8495740
export const arrayChunk = (array, chunkSize) => {
  return Array(Math.ceil(array.length / chunkSize))
    .fill()
    .map((_, index) => index * chunkSize)
    .map((begin) => array.slice(begin, begin + chunkSize));
};

export const request = async (url, params) => {
  const res = await fetch(url, params);
  if (!res.ok) {
    const responseError = await res.json();
    console.error(
      `NETWORK RESPONSE ERROR -- ${responseError.status}: `,
      responseError
    );
    throw responseError;
  }

  return res.json();
};

export const convertToCamelCase = (string) => {
  if (!string) {
    return '';
  }

  return string
    .replace(/.\b(?<word>\w)/g, (_, $1) => {
      return $1.toUpperCase();
    })
    .replace(/[\s:'"]/g, '')
    .replace(/^(?<rest>.)/u, (_, $1) => {
      return $1.toLowerCase();
    });
};

export const msToMMSS = (ms) => {
  let minutes = parseInt(ms / 60000);
  let seconds = Math.round((ms % 60000) / 1000);

  const locale = `${window.Shopify.locale}-${window.Shopify.country}`;
  minutes = minutes.toLocaleString(locale, {
    minimumIntegerDigits: 1,
    useGrouping: false,
  });
  seconds = seconds.toLocaleString(locale, {
    minimumIntegerDigits: 1,
    useGrouping: false,
  });

  return `${minutes}:${seconds}`;
};

export const escapeHtml = (unsafe) =>
  (unsafe || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');

export const decodeHtml = (html) => {
  var txt = document.createElement('textarea');
  txt.innerHTML = html;
  return txt.value;
};

export const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
